import { useMemo } from 'react';

import { dispatchSnackbarNegativeEvent } from '@dreryk/react-components';

import { faultHandlerMapTranslationKeys } from './translations';

type FaultHandlerMap = {
   'egabinet-patient:PatientExternalIdentifierRequiredFault': VoidFunction;
};

export const useFaultHandlerMap = (): FaultHandlerMap => {
   return useMemo(() => {
      return {
         'egabinet-patient:PatientExternalIdentifierRequiredFault': () => {
            dispatchSnackbarNegativeEvent(faultHandlerMapTranslationKeys.PatientExternalIdentifierRequiredFault);
         },
      };
   }, []);
};
